<template>
  <div>
    <div class="upload-bgimg-wrapper">
      <v-btn
        variant="flat"
        color="accent"
        class="upload-image-btn"
        @click="triggerUploadBgImageFromInput('bgImageMobileWebInput')"
      >
        <v-icon size="14" start>fa:fas fa-upload</v-icon>Upload Company Logo
      </v-btn>
      <RfImageFileInfo
        :image="actions.rf_settings_mobile_bg_image"
        :filename="actions.rf_settings_mobile_bg_image_filename"
      />
      <input
        ref="bgImageMobileWebInput"
        type="file"
        style="display: none"
        accept="image/*"
        @change="uploadBgImageFromInput('mobileWeb')"
      />
      <div class="upload-img-helper">width of 300px recommended</div>
    </div>
    <div style="padding: 15px 0 0; display: flex">
      <v-text-field
        v-model.trim="actions.rf_settings_bg_image_color"
        variant="outlined"
        persistentPlaceholder
        density="compact"
        label="Background color"
        hideDetails
        @blur="actions.rf_settings_bg_image_color = extendHex(actions.rf_settings_bg_image_color)"
      />
      <v-text-field
        v-model.trim="actions.rf_mobile_width"
        variant="outlined"
        persistentPlaceholder
        density="compact"
        label="Logo Width"
        hideDetails
        style="margin-left: 10px"
      />
    </div>
  </div>
</template>
<script>
import UploadImageMixin from "@/utils/UploadImageMixin";
import RfImageFileInfo from "@/components/RfPathCreate/RfRetentionActions/components/RfImageFileInfo.vue";
import { extendHex } from "@/utils/colorHelpers";

export default {
  name: "RfRetentionActionsCompanyLogo",
  components: { RfImageFileInfo },
  mixins: [UploadImageMixin],
  props: ["actions", "model", "app"],
  setup: () => ({ extendHex }),
  methods: {
    triggerUploadBgImageFromInput(displayType) {
      if (displayType === "bgImageInput") {
        this.$refs.bgImageInput.click();
      } else {
        this.$refs.bgImageMobileWebInput.click();
      }
    },
  },
};
</script>
